export const ExaminationType = [
  {"value": "unit", "text": "Unit"},
  {"value": "midterm", "text": "Midterm"},
  {"value": "final", "text": "Final"}
];